import React,{useRef, useState}  from 'react'
import {useTheme,styled } from '@mui/material/styles'
import {Box,Typography,Button, CircularProgress, Divider, Snackbar} from "@mui/material"
import MultiInput from "./MultiInput"
import TimeInput from './TimeInput';
import AutoInput from './AutoInput';
import UserInput from './UserInput'
import {IconButton} from "@mui/material"
import Radio from '@mui/material/Radio';
import {useSelector, useDispatch} from 'react-redux';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import {useNavigate} from 'react-router-dom'
import { AccountCircle, FilePresentRounded, Filter9Outlined,FormatAlignCenter } from '@mui/icons-material';
import EditorText from "./EditorText"
import SectionGeneratedAdd from './SectionGeneratedAdd';
import SectionContent from './SectionContent';
import { FileUploader } from "react-drag-drop-files";
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import ReactPlayer from 'react-player'
import axios from 'axios';

const SectionAddView = ({level,setSections})=>{

const response_types= ["simple answer"]
const levels = ["Beginner","Intermediate","Advanced","Expert"]
const languages = ["French","English","Latino","Arabic","Bengali","Chinese","Spanish","German","Korean","Dutch","Hindi","Swahili","Japanese","Hebrew","Turkish","Portuguese","Russian"]

const [title, setTitle] = useState("");
const [response_type, setResponse_type] = useState("simple answer");
const [section_level, setSection_level] = useState("Advanced");
const [section_description, setSection_description] = useState("");
const [section_questions, setSection_questions] = useState([]);
const [section_question, setSection_question] = useState("");
const [section_lang, setSection_lang] = useState("French");
const [section_date, setSection_date] = useState("");
const [section_duration, setSection_duration] = useState(0);
const [section_point, setSection_point] = useState(0);
const [total_questions, setTotal_questions] = useState(5);
const [resp, setResp] = useState("");
const user = useSelector(state => state?.auth.user);
const [resp_cor, setResp_cor] = useState("");
const [finishing, setFinishing] = useState(false);
const [showContent, setShowContent] = useState(false);
const [category, setCategory] = useState("None");
const [section_responses, setSection_responses] = useState([]);
const scrollableRef = useRef(null);
const [section_content, setSection_content] = useState([]);
const [open, setOpen] = useState(false);
const [showGenerate, setShowGenerate] = useState(false);
const [message, setMessage] = useState("");
const [file, setFile] = useState(null);
const [uploaded, setUploaded] = useState(false);
const [deleting, setDeleting] = useState(false);
const [uploading, setUploading] = useState(false);
const [hasImage, setHasImage] = useState(false);
const [hasAudio, setHasAudio] = useState(false);
const [hasVideo, setHasVideo] = useState(false);
const [url, setUrl] = useState(null);
const fileTypes = category === "Image" ? ["JPG","JPEG", "PNG", "GIF"] : category === "Video"  ? ["MP4", "AVI"] : category === "Audio"  ? ["MP3"] : ["JPG", "PNG", "GIF"];

const handleChangeFile = (file) => {
    setFile(file);
    // console.log(URL.createObjectURL(file))
  };

function handleAdd(){
    try {
        if (section_question !== "" && section_responses.length > 0) {
            
            if (total_questions > section_content?.length) {
                
                const newData = {
                    question:section_question,
                    responses:section_responses,
                    correct_responses:section_responses,
                    question_type:response_type,
                    isGenerated:false,
                    hasAudio:(hasAudio && url !== null) ? true :false,
                    hasVideo:(hasVideo && url !== null) ? true :false,
                    hasImage:(hasImage && url !== null) ? true :false,
                    audioUrl:(hasAudio && url !== null) ? url : "https://",
                    videoUrl:(hasVideo && url !== null) ? url : "https://",
                    imageUrl:(hasImage && url !== null) ? url : "https://"
                }
    
                // console.log(newData)
    
                setSection_content(prev=>[...prev,newData])
                setSection_question("")
                setSection_responses("")
                setUrl(null)
                setFile(null)
                setUploaded(false)
            } else {
                setMessage(`you have to give only less than or equal of ${total_questions} questions`)
                setOpen(true)
            }

        } else {
            setMessage("Please, enter the question or any responses")
            setOpen(true)
        }
    } catch (error) {
        console.log(error)
    }
}

function handleAddSection(){
    try {

        setFinishing(true)

        if (title !== "" && section_description !== "" && section_lang !== "" && section_duration !== "") {

            const data = {
                title:title,
                description:section_description,
                duration:parseInt(section_duration),
                total_point:parseInt(section_point),
                total_questions:parseInt(total_questions),
                level:section_level,
                language:section_lang,
                questions:section_content
            }

            console.log(data)

            setSections(prev=>[...prev,data])
            setSection_description("")
            setSection_duration(0)
            setTitle("")
            setSection_content([])
            setMessage("The section has been added")
            setOpen(true)
            
            if (scrollableRef?.current) {
                scrollableRef?.current?.scrollTo({
                  top: 0,
                  behavior: 'smooth', // Optional for smooth scrolling
                });
              }

        } else {
            setMessage("Please, fill all the required field")
            setOpen(true)
            if (scrollableRef?.current) {
                scrollableRef?.current?.scrollTo({
                  top: 0,
                  behavior: 'smooth', // Optional for smooth scrolling
                });
              }
        }
        setFinishing(false)
    } catch (error) {
        console.log(error)
    }
}

async function handleUploadFile(){
    try {

        setUploading(true)

        let formData = new FormData()

        formData.append("file",file)

        const upload = await axios.post(`${process.env.REACT_APP_SOCKET_URL}api/data/file/upload/`,formData,{
            headers:{
                "Content-Type":"multipart/form-data",
                "Authorization":`Bear ${user?.accessToken}`
            }
        }).catch(err=>{
            setMessage("Error while uploading")
            setOpen(true)
            console.log(err)
        })

        if (upload?.status == 200 && upload?.data?.success) {
            setUrl(upload?.data?.url)
            setFile(null)
            setMessage("file uploaded on the server")
            setOpen(true)
            setUploading(false)
            setUploaded(true)
        } else {
            setMessage(upload?.data?.message)
            setOpen(true)
            setUploading(false)
        }
        
    } catch (error) {
        console.log(error)
        setUploading(false)
    }
}

async function handleDeleteFile(){
    try {

        setDeleting(true)

        const data ={
            url:url
        }

        const upload = await axios.post(`${process.env.REACT_APP_SERVER_AUTH_URL}/delete-file`,data,{
            headers:{
                "Content-Type":"application/json",
                "Authorization":`Bear ${user?.accessToken}`
            }
        }).catch(err=>{
            setMessage("Error while deleting")
            setOpen(true)
            console.log(err)
        })

        if (upload?.status == 200 && upload?.data?.success) {
            setUrl(null)
            setMessage(upload?.data?.message)
            setOpen(true)
            setDeleting(false)
            setUploaded(false)
        } else {
            setMessage(upload?.data?.message)
            setOpen(true)
            setDeleting(false)
        }
        
    } catch (error) {
        console.log(error)
        setDeleting(false)
    }
}

function handleGeneratedAdd(data){
    try {
        setSection_content(prev=>[...prev,data])

        setMessage("the Question has been added")
        setOpen(true)
    } catch (error) {
        console.log(error)
    }
}


    return (
        <>
            <Typography mt={2} style={{fontSize:15,fontWeight:400,fontFamily:"dinofans"}}>
                Sections detail
            </Typography>
            <Snackbar 
					anchorOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}} 
					message={message} 
					onClose={()=>{setOpen(false)}} 
					open={open} 
					autoHideDuration={2000}
				/>
            <Box ref={scrollableRef} display="flex" flexDirection="row" flexWrap="wrap" justifyContent="space-between" m={1} alignItems="flex-start" sx={{width:"100%"}}>
                <UserInput
                    label="Title *"
                    isPass={false}
                    input={title}
                    setInput={setTitle}
                >
                    <FormatAlignCenter/>
                </UserInput>
                <AutoInput
                    data={levels}
                    setInput={setSection_level}
                    input={section_level}
                    label="Level"
                />
                 <UserInput
                    label="Duration(min) *"
                    isPass={false}
                    input={section_duration}
                    setInput={setSection_duration}
                >
                    <FormatAlignCenter/>
                </UserInput>
                <AutoInput
                    data={languages}
                    setInput={setSection_lang}
                    input={section_lang}
                    label="Language"
                />
                <UserInput
                    label="Total point *"
                    isPass={false}
                    input={section_point}
                    setInput={setSection_point}
                >
                    <FormatAlignCenter/>
                </UserInput>
                <UserInput
                    label="Total questions *"
                    isPass={false}
                    input={total_questions}
                    setInput={setTotal_questions}
                >
                    <FormatAlignCenter/>
                </UserInput>
                <Box width="95%">
                    <EditorText
						data={section_description}
						setData={setSection_description}
						width="95%"
						label="Description"
						isRequired={true}
					/>
				</Box>
            </Box>
            <Divider/>
            <Box display="flex" flexDirection="row" flexWrap="wrap" justifyContent="space-between" p={1} mt={2} alignItems="center" sx={{width:"65%"}}>
                <Typography  style={{fontSize:15,fontWeight:400,fontFamily:"dinofans"}}>
                    Section Content
                </Typography>   
                <IconButton onClick={()=>{
                    setShowContent(true)
                }}>
                    <Typography sx={{fontSize:15,fontWeight:400,}}>
                        {section_content?.length}
                    </Typography>
                    <FilePresentRounded/>
                </IconButton>             
            </Box>
            <Box display="flex" flexDirection="row" flexWrap="wrap" justifyContent="space-between" mt={2} alignItems="center" sx={{width:"90%"}}>
                <Typography mt={2} ml={3}  style={{fontSize:12,fontWeight:400,fontFamily:"dinofans"}}>
                    Add an assessment question
                </Typography>
                 <Button onClick={(e)=>{
                    e?.preventDefault()
                    setShowGenerate(true)
                }} sx={{background:"gold",color:"black",borderColor:"gold",fontFamily:"dinofans",fontSize:10,marginTop:2}} variant="contained">
                    Generate
                </Button> 
            </Box>
            <Box display="flex" flexDirection="row" flexWrap="wrap" justifyContent="space-between" m={1} alignItems="flex-start" sx={{width:"100%"}}>
                <Box justifyContent="center" alignItems="center" width="100%">
                    <FormControl>
                        <FormLabel sx={{fontFamily:"dinofans",fontSize:12,color:"gold"}} id="demo-row-radio-buttons-group-label">Category</FormLabel>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                        >
                            <FormControlLabel  value="None" control={<Radio sx={{fontSize:11,color:"#ff0"}} onClick={()=>{
                                setCategory("None")
                                setHasAudio(false)
                                setHasImage(false)
                                setHasVideo(false)
                                setFile(null)
                                }} />} label={<Typography  sx={{fontSize:12}}>None</Typography>} />
                            <FormControlLabel value="Image" control={<Radio sx={{fontSize:11,color:"#ff0"}} onClick={()=>{
                                setCategory("Image")
                                setHasAudio(false)
                                setHasImage(true)
                                setHasVideo(false)
                                setFile(null)
                                }} />} label="Image" />
                            <FormControlLabel value="Video" control={<Radio sx={{fontSize:11,color:"#ff0"}} onClick={()=>{
                                setCategory("Video")
                                setHasAudio(false)
                                setHasImage(false)
                                setHasVideo(true)
                                setFile(null)
                                }} />} label={<Typography  sx={{fontSize:12}}>Video</Typography>} />
                            <FormControlLabel value="Audio" control={<Radio sx={{fontSize:11,color:"#ff0"}} onClick={()=>{
                                setCategory("Audio")
                                setHasAudio(true)
                                setHasImage(false)
                                setHasVideo(false)
                                setFile(null)
                            }} />} label={<Typography  sx={{fontSize:12}}>Audio</Typography>} />
                        </RadioGroup>
                    </FormControl>
                </Box>
                {
                    (category === "Image" && file !== null) && (
                        <Box pl={2} mt={2} justifyContent="center" alignItems="center" width="100%">
                            <img resizemode="cover" src={URL.createObjectURL(file)} width={100} height={100} style={{borderRadius:5}}/>
                        </Box>
                        
                    )
                }
                {
                    (category === "Video" && file !== null) && (
                        <Box pl={2} mt={2} justifyContent="center" alignItems="center" width="100%">
                            <ReactPlayer url={URL.createObjectURL(file)} width={350} height={250} controls style={{borderRadius:5}}/>
                        </Box>
                        
                    )
                }
                {
                    (category === "Audio" && file !== null) && (
                        <Box pl={2} mt={2} justifyContent="center" alignItems="center" width="100%">
                            <audio src={URL.createObjectURL(file)} controls style={{width:"50%",height:50}}/>
                        </Box>
                        
                    )
                }
                {
                    category !== "None" && (
                        <Box pl={2} mt={2} justifyContent="center" alignItems="center" width="100%">
                            <FileUploader onDrop={(file)=>{setFile(file)}} maxSize={5} multiple={false} handleChange={handleChangeFile} name="file" types={fileTypes} />
                        </Box>
                        
                    )
                }
                {
                    category !== "None" && (
                        <Box pl={2} mt={2} justifyContent="center" alignItems="center" width="100%">
                            <Typography  ml={3}  style={{fontSize:12,fontWeight:400}}>
                                You have to upload a file with the size of 5MB or less
                            </Typography>
                        </Box>
                        
                    )
                }
                {
                    category !== "None" && (
                        <Box display="flex" flexDirection="row" pl={2} mt={2} justifyContent="flex-start" alignItems="flex-start" width="100%" alignContent="flex-start">
                            <Button onClick={(e)=>{
                                    e?.preventDefault()
                                    if(file){
                                        handleUploadFile()
                                    }else{
                                        setMessage("you have to upload a file")
                                        setOpen(true)
                                    }
                                }} disabled={uploading ? uploading : uploaded} sx={{background:"maroon",color:"#fff",borderColor:"gold",fontFamily:"dinofans",fontSize:10,marginBottom:3,margin:1}} variant="contained">
                                   {
                                    uploading ? "..." : " Upload"
                                   }
							</Button> 
                            {
                                (uploaded) && (
                                    <Button onClick={(e)=>{
                                    e?.preventDefault()
                                    if(url){
                                        handleDeleteFile()
                                    }else{
                                        setMessage("you have to upload a file")
                                        setOpen(true)
                                    }
                                }} disabled={deleting} sx={{background:"maroon",color:"#fff",borderColor:"gold",fontFamily:"dinofans",fontSize:10,marginBottom:3,margin:1}} variant="contained" >
                                   {
                                    deleting ? "..." : " Delete"
                                   }
							</Button>
                                )
                            } 
                        </Box>
                        
                    )
                }
                <MultiInput
                    label="Question *"
                    input={section_question}
                    isPass={false}
                    setInput={setSection_question}
                >
                    <FormatAlignCenter/>
                </MultiInput>
                <AutoInput
                    data={response_types}
                    setInput={setResponse_type}
                    input={response_type}
                    label="response type"
                />
                {
                    response_type !== "selection" && (
                        <>
                            <MultiInput
                                label="correct response *"
                                input={resp}
                                isPass={false}
                                widthSize={500}
                                setInput={setResp}
                            >
                                <FormatAlignCenter/>
                            </MultiInput>
                            <Box width="100%" mt={1}>
                                <Button onClick={(e)=>{
                                    e?.preventDefault()
                                    if(resp !== ""){
                                        setSection_responses(prev=>[...prev,resp])
                                        setResp("")
                                    }
                                }} sx={{background:"maroon",color:"#fff",borderColor:"gold",fontFamily:"dinofans",fontSize:10,marginBottom:3}} variant="contained">
                                    Add
                                </Button>                                
                            </Box>

                        </>
                    )
                }
            </Box>
            <Button onClick={(e)=>{
				e?.preventDefault()
                if(file && category !== 'None'){
                    setMessage("You have to upload first your file before adding this question content")
                    setOpen(true)
                }else{
                    handleAdd()
                }
			}} sx={{background:"gold",color:"black",borderColor:"gold",fontFamily:"dinofans",fontSize:10,marginLeft:2,marginBottom:3}} variant="contained">
				Add question
			</Button> 
            <SectionGeneratedAdd level={level} lang={section_lang} visible={showGenerate} setVisible={setShowGenerate} handleGeneratedAdd={handleGeneratedAdd} section_content={section_content} total_questions={total_questions}/>
            <Divider/>
            <Box m={3}  justifyContent="space-evenly" alignItems="center" width="40%">
                <Button sx={{background:"#fff",color:"#000",fontFamily:"dinofans",fontSize:12}} disabled={finishing ? true : false} onClick={()=>{handleAddSection()}}>
                    {
                        finishing ? "..." : "ADD SECTION"
                    }
                </Button>
            </Box>
            <SectionContent visible={showContent} setVisible={setShowContent} setData={setSection_content} data={section_content}/>
        </>
    )	
}


export default SectionAddView


